import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersisted from './plugins/VuexPersisted'
import VuexMiddleware from './plugins/VuexMiddleware'

import sipModule from './modules/sipModule'
import authModule from './modules/authModule'
import userModule from './modules/userModule'
import agentModule from './modules/agentModule'
import uploadModule from './modules/uploadModule'
import socketModule from './modules/socketModule'
import notifierModule from './modules/notifierModule'
import settingsModule from './modules/settingsModule'
import calendarModule from './modules/calendarModule'
import connectionModule from './modules/connectionModule'
import attendanceModule from './modules/attendanceModule'
import quickAnswersModule from './modules/quickAnswersModule'
import broadcastChannelModule from './modules/broadcastChannelModule'

Vue.use(Vuex)

const modules = {
  sipModule,
  authModule,
  userModule,
  agentModule,
  socketModule,
  notifierModule,
  uploadModule,
  settingsModule,
  calendarModule,
  attendanceModule,
  connectionModule,
  quickAnswersModule,
  broadcastChannelModule
}

let store = null
let getStore = null

getStore = () => {
  if (!store) {
    store = new Vuex.Store({
      modules,
      plugins: [
        VuexMiddleware(modules),
        VuexPersisted({
          reducer: ({ settingsModule, calendarModule, attendanceModule }) => {
            if (!settingsModule) return {}

            const { error, loading, ...persisted } = settingsModule
            return { settingsModule: persisted }
          }
        })
      ]
    })

    setTimeout(() => store.dispatch('settingsModule/updateDTMFOutputDevices'), 500)
  }

  return store
}

document.getStore = getStore

export default getStore
